export var CARD_IMAGES = {
    cardFrontPortrait: './assets/images/manipulative/cards/popup/cardFrontPortrait.svg',
    cardBackPortrait: './assets/images/manipulative/cards/popup/cardBackPortrait.svg',
    deckLandscape: './assets/images/manipulative/cards/popup/deckLandscape.svg',
    deckPortrait: './assets/images/manipulative/cards/popup/deckPortrait.svg',
    cardFrontLandscape: './assets/images/manipulative/cards/popup/cardFrontLandscape.svg',
    cardBackLandscape: './assets/images/manipulative/cards/popup/cardBackLandscape.svg',
};
export var GRADES = [
    // Grade K
    { value: 'K', id: 'k' },
    // Grade 1
    { value: '1', id: '1' },
    // Grade 2
    { value: '2', id: '2' },
    // Grade 3
    { value: '3', id: '3' },
    // Grade 4
    { value: '4', id: '4' },
    // Grade 5
    { value: '5', id: '5' },
];
export var MIN_CARD_COUNT = 1;
export var MAX_CARD_COUNT = 10;
